export default "__VITE_ASSET__DKIdVrwZ__"